/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ff0248fbd584c164815fdffbb6aff5e4a91e8b52";
